/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Contact_Privacy_BodyInputs */

const en_platform_contact_privacy_body = /** @type {(inputs: Platform_Contact_Privacy_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your clients, plans and history are yours. Ask for an export or a deletion any time.`)
};

const pl_platform_contact_privacy_body = /** @type {(inputs: Platform_Contact_Privacy_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoi podopieczni, plany i historia należą do Ciebie. W każdej chwili poproś o eksport albo usunięcie.`)
};

/**
* | output |
* | --- |
* | "Your clients, plans and history are yours. Ask for an export or a deletion any time." |
*
* @param {Platform_Contact_Privacy_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_contact_privacy_body = /** @type {((inputs?: Platform_Contact_Privacy_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Contact_Privacy_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_contact_privacy_body(inputs)
	return en_platform_contact_privacy_body(inputs)
});